// extracted by mini-css-extract-plugin
module.exports = {"MysqlDbDashboard":"MysqlDbDashboard_C1uS4"};